import React from "react";

function formatCurrency(num) {
  if (num === null || num === undefined) return "\u2014";
  return `R$ ${num.toLocaleString("pt-BR", { maximumFractionDigits: 2, minimumFractionDigits: 2 })}`;
}

/**
 * Tabela genérica reutilizável da tela PLCom (mesmo padrão visual/estrutural
 * do RateTable da aba Reforma Tributária — ver
 * ../../reforma-tributaria/components/RateTable.js).
 * columns: [{ key, label, align?, type?: "currency" | "text" }]
 * rows: array de objetos. `row.destaque` aplica classe `row-<destaque>`
 * (ex: "total" para destacar linha de totais).
 */
export default function RateTable({ title, columns, rows }) {
  return (
    <div className="rate-table">
      {title && <h4>{title}</h4>}
      <table>
        <thead>
          <tr>
            {columns.map((col) => (
              <th key={col.key} style={col.align ? { textAlign: col.align } : undefined}>
                {col.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, i) => (
            <tr key={i} className={row.destaque ? `row-${row.destaque}` : undefined}>
              {columns.map((col) => {
                const value = row[col.key];
                if (col.type === "currency") {
                  return (
                    <td key={col.key} style={{ textAlign: col.align || "right" }}>
                      {formatCurrency(value)}
                    </td>
                  );
                }
                if (col.type === "tag") {
                  if (!value) return <td key={col.key} />;
                  return (
                    <td key={col.key} style={{ textAlign: col.align || "left" }}>
                      <span className="rate-tag">{value}</span>
                    </td>
                  );
                }
                return (
                  <td key={col.key} style={col.align ? { textAlign: col.align } : undefined}>
                    {value === null || value === undefined || value === "" ? (col.type === "currency" ? "\u2014" : value) : value}
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
